import { Trans, useTranslation } from 'react-i18next';

import { Link, Stack, Typography } from '@mui/material';

import { i18nNS } from '../../../i18n';
import WebIcon from '../../../icons/WebIcon';

export interface NoCoursesProps {
  className?: string;
}

const NoCourses = ({ className }: NoCoursesProps) => {
  const { t } = useTranslation([i18nNS.COURSE]);

  return (
    <Stack justifyContent="center" alignItems="center" className={className}>
      <Stack alignItems="center" gap={2}>
        <WebIcon size={48} color="grey.300" />
        <Stack gap={4} width={270}>
          <Typography variant="h6Medium" component="p" textAlign="center">
            {t('you_have_not_created_a_course_yet', { ns: i18nNS.COURSE })}
          </Typography>
          <Typography variant="h6Medium" component="p" textAlign="center">
            <Trans
              t={t}
              ns={i18nNS.COURSE}
              i18nKey="click_here_to_launch_acadly_s_web_application_and_create_a_course"
            >
              Click <Link href={process.env.REACT_APP_ACADLY_WEB_URL}>here</Link> to launch Acadly's web
              application and create a course
            </Trans>
          </Typography>
          <Typography variant="h6Medium" component="p" textAlign="center">
            {t('your_first_course_is_free', { ns: i18nNS.COURSE })}
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default NoCourses;
